import { render } from "./SyllabusView.vue?vue&type=template&id=36c9728a"
import script from "./SyllabusView.vue?vue&type=script&lang=js"
export * from "./SyllabusView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__